/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { findListingEntity } from './helpers/entityReadHelpers';
import { upsertListing } from './helpers/entityAdapter';
import { setActiveTabByProductChannel } from './helpers/uiAdapter';
import { formatProductUpdateErrorMessage } from './helpers/formatProductUpdateErrorMessage';

export const updateListing = createAsyncThunk(
  'products/updateListing',
  async ({
    listingId, masterProductId, channelId, data,
  }, {
    extra: {
      sdk, Logger, Toast, utils,
    },
  }) => {
    try {
      const { data: updatedListing } = await sdk.products.updateListing(listingId, data);
      return { masterProductId, channelId, updatedListing };
    } catch (error) {
      const rawMessage = utils.getDataFromResponceError(error, 'msg');
      const errorMessage = rawMessage
        ? formatProductUpdateErrorMessage(rawMessage)
        : 'Cannot update listing';
      Toast(errorMessage, { type: 'error', autoClose: 5000 });
      Logger.error(new Error('Error updating listing'), { error }, [
        'UpdateListingFailed',
        { errorMessage: rawMessage || errorMessage || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(updateListing.pending, (state) => {
      state.isBusy = true;
      state.error = null;
    })
    .addCase(updateListing.fulfilled, (state, { payload }) => {
      const { masterProductId, channelId, updatedListing } = payload;
      state.isBusy = false;
      const existingListing = findListingEntity(state, { masterProductId, channelId });
      if (!existingListing) return;

      if (existingListing.listingStatus !== updatedListing.listingStatus) {
        setActiveTabByProductChannel(state, masterProductId, channelId, updatedListing.listingStatus);
      }

      upsertListing(state, {
        ...existingListing,
        ...updatedListing,
        masterProductId,
      });
    })
    .addCase(updateListing.rejected, (state, { error }) => {
      state.isBusy = false;
      state.error = error?.message || 'Cannot update listing';
    });
};
